import {ProductFile} from './product-file';

export class Product {
    name: string;
    categoryUrl: string;
    description: string;
    priceAmount: number;
    priceCurrency: string;
    isbn: string;
    url: string;
    file: ProductFile;
    quantity: number;
}
